import React from "react";
import { Menu, Item } from "react-contexify";
import { Icon } from "../_components";
import { useModal, useMaps } from "../_contexts";

export function MapMenu() {
  const { openModal } = useModal();
  const { interactiveMode, toggleInteractiveMode } = useMaps();

  const handleCreateMarker = (event) => {
    // console.log('Show the Modal!', event);
    openModal("mapMarker", { event });
    if (interactiveMode) {
      toggleInteractiveMode(false);
    }
  };

  return (
    <Menu
      id="chronos-map-context-menu"
      className="chronos-context-menu chronos-context-map-menu"
    >
      <Item onClick={handleCreateMarker}>
        <Icon icon="fas fa-plus fa-fw" />
        &nbsp; Create Marker
      </Item>
    </Menu>
  );
}
